// extracted by mini-css-extract-plugin
export default {"warningText":"DataIntermittence_warningText__RpOAc","validText":"DataIntermittence_validText__-KFHc"};